import {isNotNil} from 'ramda';

import type {CommonAddressResponseBody} from '../../../api/types/onlineOfferTypes';
import {formatTestDriveAddressLine} from './formatTestDriveAddressLine';

const GOOGLE_MAPS_SEARCH_URL = 'https://www.google.com/maps/search/';

export function buildGoogleMapsUrl(address: CommonAddressResponseBody): string {
  const coordinates = address.coordinates;
  const url = new URL(GOOGLE_MAPS_SEARCH_URL);
  url.searchParams.set('api', '1');

  if (isNotNil(coordinates)) {
    url.searchParams.set('query', `${coordinates.latitude},${coordinates.longitude}`);
  } else {
    url.searchParams.set('query', formatTestDriveAddressLine(address));
  }

  return url.toString();
}
